<template>
    <div class="overflow-x-hidden">
        <section
            id="contact-form"
            class="contact-form-section  md:mt-4 grid flex flex-column justify-content-center align-items-center md:px-8 relative">
             <img 
                :src="image" 
                alt=""
               class="decoration"
            >
            <div id="contact-us" class="container px-4 md:px-6 relative">
                <div class="grid ">
                    <div class="col-12 lg:col-6 md:px-5">
                        <div class="contact-form-container p-5 shadow-4">
                            <h2 class="H5-SemiBold mb-4">Send Us a Message</h2>
                            <Form class="grid w-full" @submit.prevent="sendMessage">
                            <div class="col-12">
                                <label for="fullName" class="block Label mb-2">Name</label>
                                <InputText
                                id="fullName"
                                v-model="fullName"
                                type="text"
                                placeholder="Enter full name here"
                                class="w-full"
                                variant="filled"
                                size="small"
                                />
                            </div>

                            <div class="col-12">
                                <label for="email" class="block Label mb-2">Email</label>
                                <InputText
                                id="email"
                                v-model="email"
                                type="email"
                                placeholder="Enter email here"
                                class="w-full"
                                variant="filled"
                                size="small"
                                />
                            </div>

                            <div class="col-12">
                                <label for="mobile" class="block Label mb-2">Mobile Number</label>
                                <InputText
                                id="mobile"
                                v-model="mobile"
                                type="tel"
                                placeholder="Enter mobile number here"
                                class="w-full"
                                variant="filled"
                                size="small"
                                />
                            </div>

                            <div class="col-12">
                                <label for="message" class="block Label mb-2">Message</label>
                                <Textarea
                                id="message"
                                v-model="message"
                                rows="5"
                                placeholder="Enter your message here"
                                class="w-full"
                                variant="filled"
                                size="small"
                                />
                            </div>

                            <div class="col-12 w-full">
                                <Button
                                label="Send Message"
                                class="community-button w-full"
                                type="submit"
                                :loading="loading"
                                :disabled="loading"
                                />
                            </div>

                            <div v-if="error" class="col-12">
                                <small class="p-error">{{ error }}</small>
                            </div>
                            <div v-if="success" class="col-12">
                                <small class="text-green-600">{{ success }}</small>
                            </div>
                            </Form>
                        </div>
                    </div>


                    <div class="col-12 lg:col-6">
                        <div class="contact-info p-5  h-full">
                            <span class="badge mb-2">Join with</span>
                            <h2 class="LandingPage-Title mb-4">Contact Us Today!</h2>

                            <p class="mb-6 label leading-relaxed">
                                Whether you're here to learn, to teach, or to make education better — welcome to
                                Ilearn'd
                                Tutors.
                                Together, we're redefining how Sri Lanka learns.
                            </p>
                            <div class="flex flex-column">
                                <div class="col-12 md:col-6">
                                    <div class="flex align-items-start gap-3 h-full">
                                        <div class="pt-3">
                                            <div class="contact-icon bg-blue-100 p-3 border-round-lg flex-shrink-0">
                                                <i class="pi pi-phone text-xl text-blue-600"></i>
                                            </div>
                                        </div>
                                        <div class="flex flex-column justify-content-start">
                                            <p class="Paragraph-Medium mb-1">Phone Support</p>
                                            <p class="Label mb-0">+94 710556677</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 md:col-6">
                                    <div class="flex align-items-start gap-3 h-full">
                                        <div class="pt-3">
                                            <div class="contact-icon bg-green-100 p-3 border-round-lg flex-shrink-0">
                                                <i class="pi pi-envelope text-xl text-green-600"></i>
                                            </div>
                                        </div>
                                        <div class="flex flex-column justify-content-start">
                                            <p class="Paragraph-Medium mb-1">Email Support</p>
                                            <p class="Label mb-1">support@ilearndsl.com</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import { ref, defineProps } from 'vue';
defineProps({
    image:null
})
import { backendApi } from '@/api/axios';
import { CONTACT_ENDPOINTS } from '@/api/endpoints';

const fullName = ref('');
const email = ref('');
const mobile = ref('');
const message = ref('');
const loading = ref(false);
const error = ref('');
const success = ref('');

const sendMessage = async () => {
  error.value = '';
  success.value = '';

  if (!fullName.value || !email.value || !message.value) {
    error.value = 'Full name, email, and message are required.';
    return;
  }

  loading.value = true;
  try {
    await backendApi.post(CONTACT_ENDPOINTS.SEND, {
      fullName: fullName.value,
      email: email.value,
      mobile: mobile.value,
      message: message.value,
    });
    success.value = 'Message sent successfully.';
    fullName.value = '';
    email.value = '';
    mobile.value = '';
    message.value = '';
  } catch (err) {
    error.value = err?.response?.data?.message || 'Failed to send message.';
  } finally {
    loading.value = false;
  }
};
</script>
<style scoped>
.decoration {
    position: absolute;
    bottom: 10%;
    right: 0;
    z-index: 1;
    height: 350px;
    object-fit: contain;
}

/* Responsive styles */
@media (max-width: 768px) {
    .decoration {
        height: 200px;
    }
}

@media (max-width: 480px) {
    .decoration {
        height: 150px;
    }
}
</style>